import React, { createContext, useState, useEffect } from "react";

export const PageContext = createContext();

function PageContextProvider(props) {
	const [errorMessage, setErrorMessage] = useState("");
	const [infoMessage, setInfoMessage] = useState("");
	const [confirmDialog, setConfirmDialog] = useState({});
	const [infoDialog, setInfoDialog] = useState({});
	const [runningJobs, setRunningJobs] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [config, setConfig] = useState({});

	const addRunningJob = (key, title, subtitle, startTime, icon) => {
		setRunningJobs(runningJobs => [...runningJobs,{key,title,subtitle,startTime,icon}])
	}

	const removeRunningJob = (key) => {
		setRunningJobs(runningJobs => runningJobs.filter(job => job.key !== key));
	}

	return (
		<PageContext.Provider
			value={{
				errorMessage,
				setErrorMessage,
				infoMessage,
				setInfoMessage,
				confirmDialog,
				setConfirmDialog,
				infoDialog,
				setInfoDialog,
				isLoading,
				setIsLoading,
				runningJobs,
				addRunningJob,
				removeRunningJob,
				config
			}}
		>
			{props.children}
		</PageContext.Provider>
	);
}

export default PageContextProvider;
